module.exports = __webpack_public_path__ + "img/dataReport_2.65e6e1f1.png";